
import React, { Component } from "react";
import "./TripTimeline.css"; 
class TripTimeline extends Component {
  render() {
    const { movement_data } = this.props.tripData;

    // Sort movement_data by starttime
    const sortedData = [...movement_data].sort((a, b) => a.starttime - b.starttime);

    const totalDuration = sortedData[sortedData.length - 1].endtime - sortedData[0].starttime;
    const startTime = new Date(sortedData[0].starttime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });

    const endTime = new Date(sortedData[sortedData.length - 1].endtime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit',hour12: true });


    return (
      <div className="timeline-container">
        <div className="timeline">
          {sortedData !== undefined  && sortedData.map((segment, index) => {
            const percentage = ((segment.endtime - segment.starttime) / totalDuration) * 100;
            return (
              <div
                key={index}
                className={`segment ${segment.status}`}
                style={{ width: `${percentage}%` }}
              >
                {segment && segment.duration && (
                  <div className="duration-label">
                    <span>{this.props.convertMilliseconds(segment.duration)}</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {/* Timeline Time Labels */}
        <div className="timeline-time-labels">
          <span className="time-label start-time">{startTime}</span>
          <span className="time-label end-time">{endTime}</span>
        </div>
        <div className="timeline-legend">
          <span className="legend-item"><span className="moving"></span> Moving</span>
          <span className="legend-item"><span className="idle"></span> Idle</span>
        </div>
      </div>
    );
  }
}

export default TripTimeline;

